import {initParallaxSection} from "../components/parallax-section";

export function initAlfaLanding() {
    if (!$('#alfa_landing').length) return;
    initParallaxSection();
}
